module.exports = __webpack_public_path__ + "static/parade-2019-house14-0a6baaadd957dd13b933ec6df0c28a24.jpg";